module.exports = __webpack_public_path__ + "static/media/Turtwig_gaussian2.eff23cdb.png";